const isIfiPhase = ({ source }) => (source || '').toUpperCase() === 'IFI';

export default isIfiPhase;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/ifiUtils.js